<template>
  <div class="i-careers-overview">
    <iCareerSearch
      v-if="userStore.isActiveReportSubscriber || userStore.isTierPremium || userStore.isCoachingSubscriber"
    />
    <div class="grid">
      <iCareerDetailsCard
        v-for="(job, index) in jobs"
        :key="job.id"
        :job="job"
        :is-first="index === 0"
        @job-page-redirect="handleCareerClick(job.id)"
      />

      <div
        v-if="!userStore.isTierComprehensiveOrHigher"
        class="unlock"
        @click="emit('open-modal-payment')"
      >
        <div class="head">Want More?</div>
        <div>Upgrade your report to get more career recommendations.</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useReportStore } from "@/stores/report"
import { useUserStore } from "@/stores/user"

import { GlobalVariables } from "@/helpers/globalVariables"

// COMPONENTS
import iCareerDetailsCard from "@/components/report/careers/CareerDetailsCard.vue"
import iCareerSearch from "@/components/report/careers/CareerSearch.vue"

// EMITS
const emit = defineEmits(["open-modal-payment"])

// ROUTERS
const router = useRouter()

// STORES AND COMPOSABLES
const userStore = useUserStore()
const reportStore = useReportStore()

// CONSTANTS
const REPORT_ROUTES = GlobalVariables.urls.report.children

// COMPUTED
const jobs = computed(() => reportStore.getRecommendedJobs)

//FUNCTIONS
const handleCareerClick = (jobId: number) => {
  router.push({
    name: REPORT_ROUTES.careers.routeName,
    params: {
      jobId
    }
  })
}
</script>

<style scoped lang="scss">
.i-careers-overview {
  @include flex(column, center, center, $gap: 30px);

  margin-top: 10px;

  .grid {
    @include grid($cols: 1fr, $rows: auto, $align-items: stretch, $gap: 15px);

    @media screen and (min-width: $breakpoint-lg) {
      @include grid($cols: 1fr 1fr, $rows: auto, $align-items: stretch, $gap: 25px);
    }

    @media screen and (min-width: $breakpoint-xl) {
      grid-template-columns: 1fr 1fr 1fr;
    }

    .unlock {
      min-height: 400px;
      padding: 20px;
      color: $pickle-bluewood800;
      border: 1px solid $zumthor100;
      font-weight: 500;
      text-align: center;
      cursor: pointer;

      @include flex(column, center, center, $gap: 50px);
      @include border-radius-lg;
      @include text-lg;

      @media screen and (min-width: $breakpoint-sm) {
        padding: 30px;
      }

      &:hover {
        background-color: $azure-radiance50;
        border: 1px solid $azure-radiance200;
      }

      .head {
        @include display-md;

        font-weight: 700;
      }
    }
  }
}
</style>
